import client from './main-client';

export const getLenderAnalyticsApi = (data) => client().get(`/lender-analytics?country=${data.country}`);
